import { createAsyncThunk } from "@reduxjs/toolkit";
import tokenApi from 'api/tokenApi';
import { formatQueryParams } from "helpers/format";

export const getTokens = createAsyncThunk("Tokens", async (params: any = {}) => {
  try {
    const response = await tokenApi.tokens(formatQueryParams(params));
    const response_add_type = (response?.data as any || [])?.filter((item: any) => (!params?.type || String(params?.type) === String(item?.type)));
    return response_add_type;
  } catch (error) {
    return error;
  }
});

export const getAllToken = async (params: any = {}) => {
  try {
    const response = await tokenApi.tokens(formatQueryParams(params));
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getQuote = async (params: any = {}) => {
  try {
    const response = await tokenApi.getQuote(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getQuoteToken = async (params: any = {}) => {
  try {
    const response = await tokenApi.getQuoteToken(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const addToken = async (data: any = {}) => {
  try {
    const response = await tokenApi.addToken(data);
    return response;
  } catch (error) {
    return error;
  }
};